export default "__VITE_ASSET__DDr63A7l__"